<div class="tw-min-w-[200px] xl:tw-min-w-[260px] tw-h-full">
  <mh-data-rate-widget
    [loading]="loading"
    [title]="'followup.summary.data-rate.detractors_rate.title' | translate"
    [grayTitle]="'followup.summary.data-rate.detractors_rate.detractors' | translate"
    [tooltipTitle]="'followup.summary.data-rate.detractors_rate.tooltip_detractors_rate'"
    [totalPercentage]="detractorsRatePercentage"
    [subTitlePercentage]="detractorsRateCount"
    [qualification]="qualificationDetractorsRate"
    [typeDescription]="'text'"
    [description]="detractorsRateDescription | translate"
    [textPrincipalButton]="'followup.summary.data-rate.detractors_rate.see_not_contacted' | translate | uppercase"
    [heigth]="heigth"
    (onViewMore)="onViewMore()">
  </mh-data-rate-widget>
</div>
